if (!customElements.get('noku-loox-arrows')) {
  customElements.define('noku-loox-arrows', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.roots = new Map();
      const css = `
        .swiper-button-prev, .swiper-button-next {
          box-sizing:border-box !important;
          width:44px !important;
          height:44px !important;
          padding:10px !important;
          border:0 !important;
          border-radius:50% !important;
          background:#F4A7B9 !important;
          color:#1E4D5C !important;
          box-shadow:0 2px 8px rgb(0 0 0 / 0.12) !important;
          transition:transform 180ms ease,box-shadow 180ms ease;
        }
        .swiper-button-prev { transform:translate(-50%,-50%) !important; }
        .swiper-button-next { transform:translate(50%,-50%) !important; }
        .swiper-button-prev svg, .swiper-button-next svg { width:24px; height:24px; transition:transform 180ms ease; }
        
        @media (hover:hover) and (pointer:fine) {
          .swiper-button-prev:hover,.swiper-button-next:hover { box-shadow:0 5px 14px rgb(30 77 92 / 0.22) !important; }
          .swiper-button-prev:hover { transform:translate(-50%,-50%) scale(1.07) !important; }
          .swiper-button-next:hover { transform:translate(50%,-50%) scale(1.07) !important; }
          .swiper-button-prev:hover svg { transform:translateX(-2px); }
          .swiper-button-next:hover svg { transform:translateX(2px); }
        }
        .swiper-button-prev:active { transform:translate(-50%,-50%) scale(0.96) !important; }
        .swiper-button-next:active { transform:translate(50%,-50%) scale(0.96) !important; }
        @media (prefers-reduced-motion:reduce) {
          .swiper-button-prev,.swiper-button-next,.swiper-button-prev svg,.swiper-button-next svg { transition:none; }
        }

        .swiper-button-prev:focus-visible, .swiper-button-next:focus-visible { outline:2px solid #1E4D5C; outline-offset:3px; }
      `;
      const styleRoot = root => {
        if (!root.querySelector('style[data-noku-arrows]')) {
          const style = document.createElement('style');
          style.dataset.nokuArrows = '';
          style.textContent = css;
          root.append(style);
        }
      };
      const update = () => {
        if (!this.isConnected) return;
        for (const widget of this.querySelectorAll('loox-dynamic-carousel-widget')) {
          const root = widget.shadowRoot;
          if (!root) continue;
          styleRoot(root);
          if (!this.roots.has(root)) {
            const observer = new MutationObserver(() => styleRoot(root));
            observer.observe(root, { childList:true });
            this.roots.set(root, observer);
          }
        }
      };
      this.observer = new MutationObserver(update);
      this.observer.observe(this, { childList:true, subtree:true });
      customElements.whenDefined('loox-dynamic-carousel-widget').then(() => {
        if (this.isConnected) requestAnimationFrame(update);
      });
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      for (const observer of this.roots?.values() || []) observer.disconnect();
      this.observer = null;
    }
  });
}
